import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cart-result w-100 text-motserrat-14 transition-015 no-select" }
const _hoisted_2 = { class: "order-details-image b-white100 m-auto pointer p-1 d-flex a-i-center j-content-center" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "w-100 d-flex a-i-center j-content-start" }
const _hoisted_5 = { class: "w-100 d-flex a-i-center j-content-center" }
const _hoisted_6 = { class: "w-100 d-flex a-i-center j-content-center direction-column" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-raleway-10 t-yellow" }
const _hoisted_9 = { class: "w-100 d-flex a-i-center j-content-center text-center w-100" }
const _hoisted_10 = { class: "w-100 d-flex a-i-center j-content-center" }
const _hoisted_11 = { class: "w-100 d-flex a-i-center j-content-center" }
const _hoisted_12 = ["src", "onClick"]

import SelectNumberCart from "@/components/select/SelectNumberCart.vue";
import { newWindow } from "@/utils/newWindow/newWindow";
import { ICartCars } from "@/store/modules/Cart/type";
import { IStore } from "@/store/types/StoreType";
import { computed, ref } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'cartResultComponent',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;

const loading = ref(computed<boolean>(() => store.getters.getLoadingCart));

const data = ref(props.data);

const store = useStore<IStore>();

// const updatePrice = () => store.commit('updatePriceById', {id: data.value.id, vat: vat.value})
const deleteData = () => {
  if (loading.value) return;
  store.commit("deleteInCart", {
    id: Number(data.value.id),
    stock: Number(data.value.stock),
  });
};

const openNewTab = () => newWindow(data.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("img", {
        class: "image-order",
        src: data.value?.product_photo_path || require('@/assets/' + 'no_image.jpg'),
        alt: data.value?.product_photo_path || 'no_img',
        onClick: openNewTab
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("span", _hoisted_4, [
      _createElementVNode("p", null, _toDisplayString(data.value?.full_name || "No info"), 1)
    ]),
    _createElementVNode("span", _hoisted_5, [
      _createVNode(SelectNumberCart, {
        button: true,
        id: data.value.id,
        placeholder: (~~data.value?.amount)?.toString() || '0',
        min: 0,
        max: 
          Number(~~data.value?.stock_amount) ||
          Number(~~data.value?.total_stock_amount) ||
          0
        ,
        step: data.value?.classificator === 'PCR' ? 4 : 1,
        value: data.value,
        stock: data.value.stock
      }, null, 8, ["id", "placeholder", "max", "step", "value", "stock"])
    ]),
    _createElementVNode("span", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(Number(
            data.value?.local_price ||
              (data.value?.price_inc_vat
                ? data.value?.price_with_vat
                : data.value?.price_without_vat) ||
              data.value.price
          ).toFixed(2) || "No info"), 1),
      _createElementVNode("p", _hoisted_8, _toDisplayString(data.value?.price_inc_vat ? _ctx.$tc("inc. VAT") : _ctx.$tc("w/o VAT")), 1)
    ]),
    _createElementVNode("span", _hoisted_9, _toDisplayString((data.value.local_discount_unit &&
        (isNaN(Number(data.value.local_discount_unit))
          ? "0.00"
          : Number(data.value.local_discount_unit) * data.value.amount)) ||
      "0.00"), 1),
    _createElementVNode("span", _hoisted_10, _toDisplayString(Number(data.value?.local_total || data.value?.total_price).toFixed(2) || "No info"), 1),
    _createElementVNode("span", _hoisted_11, _toDisplayString(data.value?.total_inc_vat
          ? Number(data.value?.local_total_with_vat || data.value.total_inc_vat).toFixed(2)
          : (
              Number(
                data.value?.local_total_with_vat || data.value?.price_with_vat || data.value.price
              ) * Number(data.value.amount)
            ).toFixed(2)), 1),
    _createElementVNode("span", {
      class: _normalizeClass(["w-100 d-flex a-i-center j-content-center", { 'loading-button': loading.value }])
    }, [
      _createElementVNode("img", {
        class: "pointer",
        src: require('@/assets/' + 'cart_delete.svg'),
        alt: "cart_delete",
        onClick: _withModifiers(deleteData, ["stop"])
      }, null, 8, _hoisted_12)
    ], 2)
  ]))
}
}

})